"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardTemplateUpdate = exports.standardTemplateSuccess = exports.standardTemplateSoftDeletedList = exports.standardTemplateSoftDeleteRestore = exports.standardTemplateSoftDelete = exports.standardTemplateReset = exports.standardTemplateList = exports.standardTemplateFetch = exports.standardTemplateError = exports.standardTemplateDelete = exports.standardTemplateBulkSoftDelete = exports.standardTemplateBulkRestore = exports.standardTemplateBulkHardDelete = exports.standardTemplateAdd = void 0;
var _standardTemplate = require("./standardTemplate.constant");
// @flow

// common success
var standardTemplateSuccess = function standardTemplateSuccess(actionType, data) {
  return {
    type: _standardTemplate.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.standardTemplateSuccess = standardTemplateSuccess;
var standardTemplateError = function standardTemplateError(actionType, error) {
  return {
    type: _standardTemplate.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.standardTemplateError = standardTemplateError;
var standardTemplateFetch = function standardTemplateFetch(data) {
  return {
    type: _standardTemplate.actionTypes.FETCH,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.standardTemplateFetch = standardTemplateFetch;
var standardTemplateList = function standardTemplateList(data) {
  return {
    type: _standardTemplate.actionTypes.LIST,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.standardTemplateList = standardTemplateList;
var standardTemplateAdd = function standardTemplateAdd(data) {
  return {
    type: _standardTemplate.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.standardTemplateAdd = standardTemplateAdd;
var standardTemplateUpdate = function standardTemplateUpdate(data) {
  return {
    type: _standardTemplate.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.standardTemplateUpdate = standardTemplateUpdate;
var standardTemplateDelete = function standardTemplateDelete(data) {
  return {
    type: _standardTemplate.actionTypes.DELETE,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.standardTemplateDelete = standardTemplateDelete;
var standardTemplateReset = function standardTemplateReset() {
  return {
    type: _standardTemplate.actionTypes.RESET
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.standardTemplateReset = standardTemplateReset;
var standardTemplateSoftDelete = function standardTemplateSoftDelete(data) {
  return {
    type: _standardTemplate.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
exports.standardTemplateSoftDelete = standardTemplateSoftDelete;
var standardTemplateSoftDeleteRestore = function standardTemplateSoftDeleteRestore(data) {
  return {
    type: _standardTemplate.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
exports.standardTemplateSoftDeleteRestore = standardTemplateSoftDeleteRestore;
var standardTemplateSoftDeletedList = function standardTemplateSoftDeletedList(data) {
  return {
    type: _standardTemplate.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
exports.standardTemplateSoftDeletedList = standardTemplateSoftDeletedList;
var standardTemplateBulkSoftDelete = function standardTemplateBulkSoftDelete(data) {
  return {
    type: _standardTemplate.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk hard deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
exports.standardTemplateBulkSoftDelete = standardTemplateBulkSoftDelete;
var standardTemplateBulkHardDelete = function standardTemplateBulkHardDelete(data) {
  return {
    type: _standardTemplate.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.standardTemplateBulkHardDelete = standardTemplateBulkHardDelete;
var standardTemplateBulkRestore = function standardTemplateBulkRestore(data) {
  return {
    type: _standardTemplate.actionTypes.BULK_RESTORE,
    payload: data
  };
};
exports.standardTemplateBulkRestore = standardTemplateBulkRestore;